import remarkBreaks from 'remark-breaks';
import ReactMarkdown from 'react-markdown';
import { Box, type BoxProps } from '@chakra-ui/react';

import type { JSX } from 'react';

import { Ul } from './Ul';
import { Ol } from './Ol';
import { Text } from './Text';
import { Link } from './Link';
import { Quote } from './Quote';
import { Heading } from './Heading';
import { CodeBlock } from './CodeBlock';
import { MarkdownProvider, type IMarkdownContextStateProps } from './context';

interface IMarkdownProps extends BoxProps {
  content: string;
  context?: IMarkdownContextStateProps;
}

export function Markdown({
  content,
  context = {},
  ...rest
}: IMarkdownProps): JSX.Element {
  return (
    <Box lineHeight='30px' {...rest}>
      <MarkdownProvider {...context}>
        <ReactMarkdown
          remarkPlugins={[remarkBreaks]}
          components={{
            ul: Ul,
            ol: Ol,
            p: Text,
            a: Link,
            h1: Heading,
            h2: Heading,
            h3: Heading,
            h4: Heading,
            h5: Heading,
            h6: Heading,
            code: CodeBlock,
            blockquote: Quote,
          }}
        >
          {typeof content === 'string'
            ? content.replace(/\n\n/g, '\n&nbsp;\n').replace(/\n/g, ' \n')
            : content}
        </ReactMarkdown>
      </MarkdownProvider>
    </Box>
  );
}
